import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "product-box-wide__segment-image" }
const _hoisted_2 = {
  key: 0,
  class: "product-box-wide__product-flags"
}
const _hoisted_3 = { class: "lazy-load-image product-box-wide__image" }

import {inject} from 'vue';
  import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import Flags from '../../../bps/components/flags/flags.vue';
  import ImageElement from '../../../bps/components/imageElement/imageElement.vue';
  import {ProductBoxWideSettings} from './productBoxWideSettings';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductBoxWideSegmentImage',
  props: {
    productBoxData: {},
    settings: {},
    imgSrc: {},
    isBoxTypeVertical: { type: Boolean },
    isBottle: { type: Boolean }
  },
  setup(__props: any) {

  

  const linkTarget = inject('productBoxLinkTarget', null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.productBoxData.flags)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Flags, {
            flags: _ctx.productBoxData.flags,
            limit: 3,
            "award-limit": 1,
            "white-list": _ctx.settings.flags.whitelistImage
          }, null, 8 /* PROPS */, ["flags", "white-list"])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.productBoxData.linked ? 'a' : 'div'), {
      href: _ctx.productBoxData.linked ? _ctx.productBoxData.url : null,
      target: _ctx.productBoxData.linked ? _unref(linkTarget) : null,
      class: _normalizeClass(["product-box-wide__image-wrapper", { 'product-box-wide__image-wrapper--bottle': _ctx.isBoxTypeVertical }])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ImageElement, {
            "img-class": "lazy-load-image__image",
            src: _ctx.imgSrc,
            title: _ctx.productBoxData.images[1].title,
            alt: _ctx.productBoxData.images[1].alt,
            webp: true
          }, null, 8 /* PROPS */, ["src", "title", "alt"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["href", "target", "class"]))
  ]))
}
}

})